/**
 * Key Numbers 1055 — KUK home Stats.
 * Icon / count / label rows in `metadata` on a gradient bar.
 */

export const KEY_NUMBERS_1055_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Stats",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_icon_color: "#FFFFFF",
    meta_count: "",
    meta_title: "",
    meta_priority: 1,
    meta_status: true,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "gradient_color_1",
      label: "Band gradient — start",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_2",
      label: "Band gradient — end",
      value: "#1E40AF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1E40AF",
    },
    {
      fieldName: "gradient_color_3",
      label: "Divider colour",
      value: "#93C5FD",
      valueType: "string",
      filedType: "COLOR",
      description: "The vertical rule between neighbouring stats.",
      defaultValue: "#93C5FD",
    },
    {
      fieldName: "title_start_color",
      label: "Count colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description_color",
      label: "Label colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description",
      label: "Count suffix",
      value: "+",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "+",
      description: "Appended to every count. Leave empty to drop it.",
      defaultValue: "+",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon name (e.g. tutor) or an image URL",
      defaultValue: "",
    },
    {
      header: "Icon colour",
      fieldName: "meta_icon_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Count",
      fieldName: "meta_count",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "26000",
      description: "Rendered with thousands separators.",
      defaultValue: "",
    },
    {
      header: "Label",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Students",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
